import { createSelector } from '@reduxjs/toolkit';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { Breakpoint, ScreenSize, selectBreakpoint, selectScreenSize } from 'store/slice/screen';
import { selectConfigFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { OverlayType, showOverlay } from 'store/slice/overlay';

interface StateProps {
    config: BootstrapConfig;
    screenSize: ScreenSize;
    breakpoint: Breakpoint;
    isNewHomePageEnabled: boolean;
    isOpenSearchOverlayOnLanding: boolean;
}

interface DispatchProps {
    showOverlay: (overlayType: OverlayType) => void;
}

export type HomePageProps = StateProps & DispatchProps;

export const mapStateToProps = createSelector(
    selectConfigFromBootstrap,
    selectScreenSize,
    selectBreakpoint,
    selectFeatureBehaviorFromBootstrap,
    (config, screenSize, breakpoint, featureBehaviours): StateProps => {
        return {
            config,
            screenSize,
            breakpoint,
            isNewHomePageEnabled: featureBehaviours.HomePageV2Layout,
            isOpenSearchOverlayOnLanding: featureBehaviours.OpenSearchOverlayOnLanding,
        };
    },
);

export const mapDispatchToProps = (dispatch: Function): DispatchProps => {
    return {
        showOverlay: (overlayType: OverlayType) => {
            dispatch(showOverlay(OverlayType.TextSearch));
        },
    };
};
